var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass: "user-chat-box bg-light card text-sm",
    },
    [
      _c(
        "div",
        {
          staticClass: "card-header bg-dark text-center text-white pa-0",
          on: {
            click: _vm.toggleCollapse,
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "d-flex align-items-center pa-2",
            },
            [
              _vm.unread > 0
                ? _c(
                    "span",
                    {
                      staticClass: "badge badge-danger",
                    },
                    [_vm._v(_vm._s(_vm.unread))]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "p",
                {
                  staticClass: "flex-grow-1 mb-0",
                },
                [_vm._v("\n        💬 ติดต่อเอเจนท์\n      ")]
              ),
              _vm._v(" "),
              _c("i", {
                class: {
                  fa: true,
                  "fa-caret-down": true,
                  "d-flex": true,
                  "mr-2": true,
                  more: !_vm.isChatOpen,
                },
                attrs: {
                  id: "caret",
                },
              }),
            ]
          ),
          _vm._v(" "),
          _vm.hotnews.length > 0
            ? _c(
                "marquee",
                {
                  staticClass: "bg-primary text-white",
                  attrs: {
                    id: "marquee",
                    scrollamount: "4",
                  },
                },
                _vm._l(_vm.hotnews, function (text) {
                  return _c("div", {
                    staticClass: "d-inline-block mx-5",
                    domProps: {
                      innerHTML: _vm._s(text),
                    },
                  })
                }),
                0
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          class: {
            collapse: !_vm.isChatOpen,
          },
          attrs: {
            id: "messageWrapper",
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "card-body",
              attrs: {
                id: "messageContainer",
              },
            },
            [
              _vm.cleanLineUrl.startsWith("https://lin.ee/")
                ? _c("img", {
                    staticClass: "p-2",
                    attrs: {
                      src: _vm.qrCodeUrl,
                      alt: "LINE QR",
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.cleanLineUrl
                ? _c(
                    "p",
                    {
                      staticClass: "p-2 text-left",
                    },
                    [
                      _c(
                        "a",
                        {
                          attrs: {
                            href: _vm.cleanLineUrl,
                            target: "_blank",
                            rel: "noopener noreferrer",
                          },
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.cleanLineUrl) +
                              "\n        "
                          ),
                        ]
                      ),
                    ]
                  )
                : _vm._e(),
            ]
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }